import { FuelBadge, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex, FuelSpacer } from '@frete.com/fuel-station-react';
import Carousel from 'components/ui/Carousel';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import { DS_TOKENS } from 'constants/styled.contants';
import { textConstants } from 'constants/texts';
import { IVehicle } from 'interfaces/profile.interface';
import React, { FC } from 'react';

const DEFAULT_CAROUSEL_HEIGHT_IN_PX = 300;

const TruckDetails: FC<{ data: IVehicle }> = ({ data }) => {
  const hasImages = !!data?.images?.length;

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        customMargin: hasImages ? `${DS_TOKENS.spacing.km4} 0 ${DS_TOKENS.spacing.km6} 0` : '0',
      }}
    >
      {hasImages && (
        <>
          <Carousel height={DEFAULT_CAROUSEL_HEIGHT_IN_PX} images={data.images} />
          <FuelSpacer y="km6" />
        </>
      )}
      <GenericInfoItem title="Tipo de veículo">
        <FuelTypography size="body-md" color="neutral-strong" weight="medium">
          {data?.tractor?.type} &bull; {data?.tractor?.plate}
        </FuelTypography>
      </GenericInfoItem>
      <GenericInfoItem title="ANTT (RNTRC)">
        <>
          <FuelTypography size="body-md" color="neutral-strong" weight="medium">
            {data?.rntrc}
          </FuelTypography>
          {data?.rntrcEmissionDate && (
            <FuelFlex
              defaultProps={{
                display: 'flex',
                alignItems: 'center',
                gap: 'km1',
              }}
            >
              <FuelTypography size="caption" weight="medium" color="neutral-default">
                Cadastrado desde: {data?.rntrcEmissionDate}
              </FuelTypography>
            </FuelFlex>
          )}
        </>
      </GenericInfoItem>
      <GenericInfoItem title="Tipo de carroceria">
        {!!data?.body?.length ? (
          <>
            {data?.body?.map((bodywork, index) => (
              <FuelFlex defaultProps={{ alignItems: 'center', gap: 'km2' }} key={`bodywork-${bodywork.plate}`}>
                <FuelBadge label={`${index + 1}`} color="tertiary" />
                <FuelTypography size="body-md" color="neutral-strong" weight="medium">
                  {bodywork.name} &bull; {bodywork.plate}
                </FuelTypography>
              </FuelFlex>
            ))}
          </>
        ) : (
          <FuelTypography size="body-md" color="neutral-strong" weight="medium">
            {textConstants.noInfoText}
          </FuelTypography>
        )}
      </GenericInfoItem>
      <GenericInfoItem title="Rastreador">
        <FuelTypography size="body-md" color="neutral-strong" weight="medium">
          {data?.tracker}
        </FuelTypography>
      </GenericInfoItem>
      <GenericInfoItem title="Localizador" displayDivider={false}>
        <FuelTypography size="body-md" color="neutral-strong" weight="medium">
          {data?.locator}
        </FuelTypography>
      </GenericInfoItem>
    </FuelFlex>
  );
};

export default TruckDetails;
